import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import ChatbotAssistantChat from 'components/molecules/chatbot_assistant_chat';
import ChatbotAssistantHistory from 'components/molecules/chatbot_assistant_history';
import { updateCurrentChatId } from 'store/modules/chatbot_assistant_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ChatbotAssistantState } from 'store/modules/chatbot_assistant_store/types';
import { MenusBehaviourData, MenusBehaviourTypes } from 'store/modules/menus_behaviour_store/types';
import { track } from 'services/tracking';
import { ChatbotAssistantDrawerStyles, Container } from './styles';

const ChatbotAssistant: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedFeature, setSelectedFeature] = useState<'chat' | 'history'>('chat');

  const { chatbotAssistant: show } = useSelector<ApplicationState, MenusBehaviourData>(
    (state) => state.session.menus_behaviour.menus_behaviour,
  );

  const { chatbot_assistant, request } = useSelector<ApplicationState, ChatbotAssistantState>(
    (state) => state.session.chatbot_assistant,
  );

  const [isLoading, setIsloading] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (!show) setIsExpanded(false);
  }, [show]);

  useEffect(() => {
    if (chatbot_assistant.current_chat_messages?.length === 0) return setIsloading(false);
    if (
      chatbot_assistant.current_chat_messages[chatbot_assistant.current_chat_messages.length - 1]
        .role === 'assistant'
    )
      return setIsloading(false);
    if (!request.create_user_chat_message.loading) return setIsloading(false);

    return setIsloading(true);
  }, [request.create_user_chat_message, chatbot_assistant.current_chat_messages]);

  const closeAssistant = () => {
    dispatch({ type: MenusBehaviourTypes.CLOSE_CHATBOT_ASSISTANT });
  };

  const createNewChat = () => {
    if (chatbot_assistant.current_chat_messages?.length === 0) return;

    track('consultor_juridico.criou_chat', { acao: 'novo_chat' });
    dispatch(updateCurrentChatId(null));
    setSelectedFeature('chat');
  };

  return (
    <>
      <ChatbotAssistantDrawerStyles />
      <Modal
        onHide={closeAssistant}
        show={show}
        centered={false}
        enforceFocus={false}
        className="chatbot-assistant-drawer-modal"
        backdropClassName="chatbot-assistant-drawer-backdrop"
        dialogClassName={`chatbot-assistant-drawer-dialog${
          isExpanded ? ' chatbot-assistant-drawer-dialog--expanded' : ''
        }`}
        contentClassName="chatbot-assistant-drawer-content"
        aria-label="Consultor Jurídico"
      >
        <Container className="chatbot-assistant-container">
          <div className="chatbot">
            <div className="chatbot-tab d-flex justify-content-between">
              <div>
                <button
                  className={`${
                    selectedFeature === 'chat' && 'current'
                  } btn chatbot-tab-nav text-white`}
                  type="button"
                  onClick={() => setSelectedFeature('chat')}
                >
                  Chat
                </button>
                <button
                  className={`${
                    selectedFeature === 'history' && 'current'
                  } btn chatbot-tab-nav text-white`}
                  type="button"
                  onClick={() => setSelectedFeature('history')}
                >
                  Histórico
                </button>
              </div>

              <div className={`d-flex pr-2 ${isExpanded ? 'pr-3' : ''}`}>
                <button
                  className="btn btn-chatbot text-white btn-sm align-self-center"
                  type="button"
                  disabled={isLoading}
                  onClick={() => {
                    createNewChat();
                    setSelectedFeature('chat');
                  }}
                >
                  Novo chat
                </button>

                <button
                  type="button"
                  className="btn btn-chatbot p-1 text-white d-none d-md-flex align-items-center"
                  aria-label={isExpanded ? 'Reduzir painel' : 'Expandir painel'}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? (
                    <span className="material-icons">fullscreen_exit</span>
                  ) : (
                    <span className="material-icons">fullscreen</span>
                  )}
                </button>

                <button
                  className="btn btn-chatbot p-1 pr-2 text-white d-flex align-items-center"
                  type="button"
                  onClick={closeAssistant}
                >
                  <span className="material-icons">close</span>
                </button>
              </div>
            </div>
            <div className="chatbot-line" />
            {selectedFeature === 'chat' && <ChatbotAssistantChat isLoading={isLoading} />}
            {selectedFeature === 'history' && <ChatbotAssistantHistory />}
          </div>
        </Container>
      </Modal>
    </>
  );
};

export default ChatbotAssistant;
